import { useSyncExternalStore } from "react";
import { subscribe, getSnapshot } from "./authStore";
import {
  loginWithPassword as loginWithPasswordService,
  loginWithPin as loginWithPinService,
  logout as logoutService,
} from "./authService";
import { useDeviceId } from "@/hooks/useDeviceId";
import { useQueryClient } from "@tanstack/react-query";

export function useAuth() {
  const state = useSyncExternalStore(subscribe, getSnapshot);
  const queryClient = useQueryClient();
  const deviceId = useDeviceId();

  const isAuthenticated =
    state !== null && state.expiredAt > Math.floor(Date.now() / 1000);

  const mustChangePassword = state?.mustChangePassword ?? false;

  async function loginWithPassword(email: string, password: string) {
    await loginWithPasswordService(email, password, deviceId);
  }

  async function loginWithPin(email: string, pincode: string) {
    await loginWithPinService(email, pincode, deviceId);
  }

  function logout() {
    logoutService(queryClient);
  }

  return {
    isAuthenticated,
    mustChangePassword,
    token: state?.token ?? null,
    userID: state?.userID ?? null,
    loginWithPassword,
    loginWithPin,
    logout,
  };
}
